import { render, staticRenderFns } from "./FollowUpsTableActions.vue?vue&type=template&id=23928482&"
import script from "./FollowUpsTableActions.vue?vue&type=script&lang=js&"
export * from "./FollowUpsTableActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports